module.exports = __webpack_public_path__ + "img/form-bg-2.84f988b7.svg";